import styled from 'styled-components';

const NotificationBox = styled.div`
  height: 219px;
  margin: 0 1px 0 0;
  border-radius: 16px;
  box-shadow: 0 2px 4px 0 rgba(96, 97, 112, 0.16), 0 0 1px 0 rgba(40, 41, 61, 0.04);
  background-color: #fff;

  @media (min-width: 992px) {
    height: 409px;
  }
`;

export default NotificationBox;
